import { render, staticRenderFns } from "./DxVarietyDatabase.vue?vue&type=template&id=6a43d312&"
import script from "./DxVarietyDatabase.vue?vue&type=script&lang=js&"
export * from "./DxVarietyDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports